function Placeholder1(){
    return(
        <div style={{height:'5rem'}}/>
    );
}
export default Placeholder1